import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "src/environments/environment";
import { FEATURES } from "src/environments/features";

@Pipe({
  name: "disabledFeatures",
})
export class DisabledFeaturesFeaturesPipe implements PipeTransform {
  /**
   * Checks if the feature is disabled in the app environment.
   * true  = disabled
   * false = activated
   */
  transform(value: FEATURES): boolean {
    if (Array.isArray(environment.featuresToDisable) && environment.featuresToDisable.length) {
      return environment.featuresToDisable.includes(value) ? true : false;
    } else return false;
  }
}
